import { SgvJson } from '@eceos/arch';
import { TimeInterval } from '../time-interval';
import { InterestArrears } from "./interest-arrears";

export class SimpleInterestArrears extends InterestArrears {

  constructor(timeInterval?: TimeInterval) {
    super(0.0, timeInterval, "simple");
  }

  toJson(): any {
    return SgvJson.to.simple(this);
  }

  static fromJson(data: any): SimpleInterestArrears {
    return SgvJson.from.simple(data, SimpleInterestArrears, {
      timeInterval: InterestArrears.parseInterval(data.timeInterval)
    });
  }
}
